import DOMPurify from "dompurify";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {toast} from "react-hot-toast";
import {FaRegCopy} from "react-icons/fa6";

import Button from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {useCopyToClipboard} from "@/lib/hooks/useCopyToClipboard.ts";
import {WidgetEntity} from "@/lib/queries/statuspages.ts";
import {WidgetTheme} from "@/pages/tools/theme.js.ts";

interface UptimeWidgetPreviewProps {
  className?: string;
  link: string;
  value: WidgetEntity;
  theme: WidgetTheme;
}

export const UptimeWidgetPreview = ({className, link, value, theme}: UptimeWidgetPreviewProps) => {
  const [, copy] = useCopyToClipboard();
  const widgetURL = `${value.widget_url}?${theme}`;
  const public_details_url = link || value.public_details_url;
  const content = `<a target="_blank" title="Website Monitoring by Uptime.com" href="${public_details_url}" style="display: inline-block; width: 140px; height: 60px; margin: 0; padding: 0; border: 0; overflow: hidden; background-color: transparent; font-size: 0; line-height: 0; text-decoration: none; vertical-align: middle;"><img src="${widgetURL}" width="140" height="60" alt="Website Monitoring by Uptime.com" style="display: inline; width: 140px; height: 60px; margin: 0; padding: 0; border: 0;"></a>`;
  return (
    <div className={className}>
      <div className="">
        <span className="fw-semibold">Preview</span>
        <div className="p-1" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(content)}} />
      </div>
      <div className="form-group">
        <OverlayTrigger overlay={(props) => <Tooltip {...props}>Copy to Clipboard</Tooltip>}>
          <Button
            variant={"secondary"}
            className={"my-2"}
            onClick={async () => {
              await copy(content);
              toast.success("Widget code successfully copied to clipboard.");
            }}
          >
            Embed Code For Your Site <Icon icon={FaRegCopy} />
          </Button>
        </OverlayTrigger>
        <pre className="card card-body bg-light text-muted text-wrap">
          <code>{content}</code>
        </pre>
      </div>
    </div>
  );
};
